module.exports = __webpack_public_path__ + "static/img/keep-your-manual-up-to-date.b34daa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/keep-your-manual-up-to-date.png
// module id = hcwp
// module chunks = 0